import { render, staticRenderFns } from "./WorklistEntry.vue?vue&type=template&id=534bc906"
import script from "./WorklistEntry.vue?vue&type=script&lang=js"
export * from "./WorklistEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports